<template>
  <div class="container-raw-inline-item" :class="format">
    <div ref="rawResponse" v-html="raw"></div>
  </div>
</template>

<style lang="scss">
  .container-raw-inline-item {
    position: relative;
    width: 140%;
    left: -20%;
    height: 520px;
    overflow: hidden;
    z-index: 1;
    margin: 35px 0;
    

    &.content {
      width: 100%;
      left: 0;
      height: 520px;
    }

    &.fullsize {
      width: calc(100vw - 15px);
      height: 100vh !important;
      left: calc(((((100vw - 15px) - 100%) / 2) * -1));
      height: 520px;
    }

    img {
      width: 100%;
    }
  }
</style>

<script>

  import axios from 'axios'

  export default {
    name: 'RawInline',
    props: {
      src: {
        type: String,
        default: ``
      }
    },
    data() {
      return {
        raw: ``,
      }
    },
    watch: {
      src() {
        this.renderRaw()
      }
    },
    computed: {
      url() {
        const url=this.src.split(';')
        if(url[0]){
          return url[0]
        }
        return this.src
      },
      format() {
        const url=this.src.split(';')
        if(url[1]){
          return url[1]
        }
        return ``
      }
    },
    mounted() {
      this.renderRaw()
    },
    methods: {
      renderRaw() {
        axios.get(
          this.url
        ).then((response) => {
            this.raw = response.data
        })
      }
    }
  }
</script>